import { thunk, Thunk } from 'easy-peasy'

import { StoreModel } from './index'
import { borrowerPortalRequest } from '../services/http'

export interface TaskModel {
  hasOutstandingApplyFlowTask: Thunk<
    TaskModel,
    void,
    object,
    StoreModel,
    Promise<boolean>
  >
  addTaskByName: Thunk<TaskModel, { taskName: string }, object, StoreModel>
  updateTaskStatus: Thunk<
    TaskModel,
    { taskName: string; status: string },
    object,
    StoreModel
  >
}

const task = (): TaskModel => {
  return {
    hasOutstandingApplyFlowTask: thunk(async () => {
      const { data } = await borrowerPortalRequest(
        '/tasks/apply-flow-status',
        {},
        {},
        'get'
      )

      return data?.hasOutstandingApplyFlowTask !== false
    }),

    addTaskByName: thunk(async (_, payload) => {
      const { taskName } = payload

      await borrowerPortalRequest(
        '/tasks',
        {
          taskName,
        },
        {
          'Content-Type': 'application/json',
        }
      )
    }),

    updateTaskStatus: thunk(async (_, payload) => {
      const { taskName, status } = payload

      await borrowerPortalRequest(
        '/tasks/by-name',
        {
          taskName,
          status,
        },
        {
          'Content-Type': 'application/json',
        },
        'patch'
      )
    }),
  }
}

export default task
